var exports = {
  "kL": "xcc377c0b--bd8fb2--container",
  "Pf": "xcc377c0b--bd8fb2--label",
  "pq": "xcc377c0b--bd8fb2--info",
  "DD": "xcc377c0b--bd8fb2--title",
  "h_": "xcc377c0b--bd8fb2--description",
  "Uo": "xcc377c0b--bd8fb2--buttons",
};

module.exports = exports;
